import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { AddressView } from '@api-proxies';
import { AddressService } from '@http/clients/address.service';
import { AddressTypes } from '@models/enums/AddressTypes';
import { GenericTypeAheadDropdownComponent, IconSanitizerService } from 'ngx-lib';
import { CustomMenuItemComponent } from '../custom-menu-item/custom-menu-item.component';

interface AddressType {
    icon: SafeHtml;
    typeName: string;
}

@Component({
    selector: 'app-type-ahead-addresses',
    templateUrl: './type-ahead-addresses.component.html',
    styleUrls: ['./type-ahead-addresses.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadDropdownComponent, CustomMenuItemComponent]
})
export class TypeAheadAddressesComponent {
    globeIcon: SafeHtml;
    markerPinIcon: SafeHtml;

    @Input()
    selectedAddress?: AddressView;

    @Input()
    isReadOnly?: boolean = false;

    @Input()
    error?: boolean;

    @Output()
    selectedAddressChange = new EventEmitter<AddressView>();

    searchText = '';

    source?: AddressView[];

    addressTypes: Record<number, AddressType>;

    constructor(
        private readonly addressService: AddressService,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        this.globeIcon = this.iconSanitizer.getIcon('globe');
        this.markerPinIcon = this.iconSanitizer.getIcon('markerPin');

        this.addressTypes = {
            [AddressTypes.Address]: {
                icon: this.markerPinIcon,
                typeName: 'Address'
            },
            [AddressTypes.Block]: {
                icon: this.globeIcon,
                typeName: 'Block'
            },
            [AddressTypes.Country]: {
                icon: this.globeIcon,
                typeName: 'Country'
            },
            [AddressTypes.District]: {
                icon: this.globeIcon,
                typeName: 'District'
            },
            [AddressTypes.Locality]: {
                icon: this.globeIcon,
                typeName: 'Locality'
            },
            [AddressTypes.Neighborhood]: {
                icon: this.globeIcon,
                typeName: 'Neighborhood'
            },
            [AddressTypes.Place]: {
                icon: this.globeIcon,
                typeName: 'Place'
            },
            [AddressTypes.PostCode]: {
                icon: this.globeIcon,
                typeName: 'Post Code'
            },
            [AddressTypes.Region]: {
                icon: this.globeIcon,
                typeName: 'Region'
            },
            [AddressTypes.SecondaryAddress]: {
                icon: this.markerPinIcon,
                typeName: 'Secondary Address'
            },
            [AddressTypes.Street]: {
                icon: this.globeIcon,
                typeName: 'Street'
            }
        };
    }

    async onAddressTextChanged(): Promise<void> {
        if (this.searchText?.length > 2) {
            const limit = 10;
            this.source = await this.addressService.searchPlaces(this.searchText, limit);
        } else {
            this.source = [];
        }
    }

    onAddressChange(itemSelected: any): void {
        this.selectedAddress = itemSelected;
        this.selectedAddressChange.emit(itemSelected);
        this.source = [];
    }
}
